export const INITIAL_VALUES = {
  loanAmount: 12000,
  role: '',
}

export const VERTICAL = 'inschool'
